export default {
  loading: false,
  navigation: {},
  userProfile: {},
  msalAccount: null
};
